import { render, staticRenderFns } from "./CmgAlternatePickupLocationsModal.vue?vue&type=template&id=c705904a&scoped=true&lang=pug"
import script from "./cmg-alternate-pickup-locations-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-alternate-pickup-locations-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAlternatePickupLocationsModal.vue?vue&type=style&index=0&id=c705904a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c705904a",
  null
  
)

export default component.exports